// components/invitePartner/InviteConfirmation.jsx
import ButtonCustom from '../atoms/button/ButtonCustom'
import styles from './invite.module.scss'

export const InvitePendingView = ({ email, status, openModal }) => {
	return (
		<div className={styles.cardContainer}>
			<h2 className={styles.subTitle}>Invite Sent!</h2>
			<p>
				An invite was sent to <strong>{email}</strong>
			</p>
			<p>
				Status: <strong className={styles.status}>{status}</strong>
			</p>
            <ButtonCustom variant="destructive" onClick={() => openModal('removePartner')} className={styles.removeBtn}>Remove Partner</ButtonCustom>
		</div>
	)
}
